<lib-table [tableColumns]="campaignRegistrationColumns" [api]="api"  [exportButton]="exportButton"
[searchUIOptions]="searchUIOptions" (smHandleUpdateButtonClick)="handleUpdateButtonClick($event)"
 [resourceMessages]="resourceMessages"  [addNewButton]="false" [title]="title"></lib-table>